<script>
	import { Router, Link, Route } from "svelte-routing";
	import Reel from './Reel.svelte';
  import SearchBar from './SearchBar.svelte';
  import { user, book_lists, genres } from './stores.js';

  function log_in() {
    $user = "Antti";
  }

  function log_out() {
    $user = null;
  }

  import { onMount } from "svelte";

  onMount(() => {
    window.scrollTo(0, 0);
  });

</script>

<style>
  h2 {
    margin-top: 50px;
  }
	main {
		padding: 50px 60px;
	}

  .genres {
    margin: 20px 0;
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
  }

  .genre {
    display: block;
    width: 140px;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    background: #EEE;
    border-radius: 3px;
    margin: 5px;
    font-weight: 600;
    font-size: 14px;
    color: #333;

  }
</style>

<main>
  <h1>Discover books!</h1>

  <SearchBar />

  <!-- {#if $user}
    <h2>Hi, {$user}!</h2>
    <button on:click={log_out}>Log out</button>
  {:else}
    <h2>Hi, stranger!</h2>
    <button on:click={log_in}>Log in</button>
  {/if} -->

  {#if $user}
    <h2>Explore genres</h2>
    <div class="genres">
      {#each genres as genre}
        <a href="/explore/{genre}"><div class="genre">{genre}</div></a>
      {/each}
    </div>

    <Reel name="Continue reading" books={book_lists.series} />
    <Reel name="New books" books={book_lists.new} />
    <Reel name="Recommended for you" books={book_lists.recommended} />
    <Reel name="Because you read 'Harry Potter ja salaisuuksien kammio'" books={book_lists.fantasy} />
  {:else}
    <h2>Explore genres</h2>
    <div class="genres">
      {#each genres as genre}
        <a href="/explore/{genre}"><div class="genre">{genre}</div></a>
      {/each}
    </div>
    <Reel name="New books" books={book_lists.new} />
    <Reel name="For kids" books={book_lists.kids} />
    <Reel name="Fantasy" books={book_lists.fantasy} />
    <Reel name="Finnish classics" books={book_lists.recommended} />
  {/if}
</main>
